import { IconChevronLeftOutline, IconChevronRightOutline } from '@featuring-corp/icons';
import clsx from 'clsx';
import React, { ComponentPropsWithoutRef, ReactNode, useEffect } from 'react';
import { useSnapCarousel } from 'react-snap-carousel';

import {
	carouselListClass,
	carouselWrapperClass,
	indicatorItemClass,
	indicatorListClass,
	nextButtonClass,
	prevButtonClass,
} from './style.css';

export interface SnapCarouselProps extends ComponentPropsWithoutRef<'div'> {
	items: ReactNode[];
	indicator?: boolean;
}

const SnapCarousel = ({
	items = [],
	className,
	indicator = false,
	...props
}: SnapCarouselProps) => {
	const {
		scrollRef,
		pages,
		activePageIndex,
		prev,
		next,
		refresh,
		snapPointIndexes: _,
		goTo,
	} = useSnapCarousel();

	useEffect(() => {
		refresh();
	}, [items, refresh]);

	return (
		<>
			<div className={clsx(carouselWrapperClass, className)} {...props}>
				<ul className={carouselListClass} ref={scrollRef}>
					{items.map((item, idx) => (
						<div key={idx} /*className={snapPointIndexes.has(idx) ? snapClass : ''}*/>
							{item}
						</div>
					))}
				</ul>

				{activePageIndex > 0 && (
					<button className={prevButtonClass} onClick={() => prev()}>
						<IconChevronLeftOutline />
					</button>
				)}

				{pages.length > 0 && pages.length - 1 > activePageIndex && (
					<button className={nextButtonClass} onClick={() => next()}>
						<IconChevronRightOutline />
					</button>
				)}
			</div>

			{indicator && (
				<div className={indicatorListClass}>
					{pages.map((_, idx) => (
						<button
							key={idx}
							className={indicatorItemClass({
								active: activePageIndex === idx,
							})}
							onClick={() => {
								goTo(idx);
							}}
						/>
					))}
				</div>
			)}
		</>
	);
};

export default SnapCarousel;
